/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';

import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { outgoingBreadcrumbItems } from 'data/outgoing';
import OutgoingFilter from './filter/OutgoingFilter';
import OutgoingTable from './OutgoingTable';
import ButtonRefresh from 'components/base/ButtonRefresh';

const Outgoing = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  // const handleRefetch = () => {
  //   queryClient.refetchQueries('GET_ORDER_OUT_MAIN');
  // };

  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [optionSenderId, setOptionSenderId] = useState(null);
  const [optionStatusId, setOptionStatusId] = useState(null);
  const [optionDelivererId, setOptionDelivererId] = useState(null);

  return (
    <div>
      <PageBreadcrumb items={outgoingBreadcrumbItems} />
      <div>
        <div className="mb-5 d-flex gap-2 align-items-center">
          <h2>{t('outgoing')}</h2>
          <ButtonRefresh
            onRefresh={() => queryClient.refetchQueries('GET_ORDER_OUT_MAIN')}
          />
        </div>
        <OutgoingFilter
          dateFrom={dateFrom}
          dateTo={dateTo}
          setDateFrom={setDateFrom}
          setDateTo={setDateTo}
          setOptionSenderId={setOptionSenderId}
          setOptionStatusId={setOptionStatusId}
          optionSenderId={optionSenderId}
          optionStatusId={optionStatusId}
          setOptionDelivererId={setOptionDelivererId}
          optionDelivererId={optionDelivererId}
        />
        <OutgoingTable
          dateFrom={dateFrom}
          dateTo={dateTo}
          optionSenderId={optionSenderId}
          optionStatusId={optionStatusId}
          optionDelivererId={optionDelivererId}
        />
      </div>
    </div>
  );
};

export default Outgoing;
